import styled from 'styled-components';
import { COLOR_GRAY_60 } from 'styles/variables/colors';

export const Container = styled.div`
  margin-bottom: ${(props) => props.marginBottom}px;
`;

export const Label = styled.p`
  margin: 0;
  font-size: 0.75rem;
  font-weight: bold;
  margin-bottom: 7px;
`;

export const Input = styled.div`
  display: flex;
`;

export const IconContainer = styled.div`
  color: ${COLOR_GRAY_60};
  padding-right: 10px;
`;

export const Value = styled.p`
  margin: 0;
`;

export const ValueContainer = styled.div`
  max-width: 237px;

  & > p {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
